module.exports = __webpack_public_path__ + "img/1-03.0f0e5474.jpg";